<template>
  <div class="tag_chooser">
    <el-table
      :data="list" border style="width: 99.5%;">
      <el-table-column
        label="类别"
        prop="type_name"
        width="120">
      </el-table-column>
      <el-table-column
        label="可使用" class="tag-wrap">
        <template slot-scope="scope">
          <span v-if="!!!tag.selected" v-for="tag in scope.row.tag_list" :key="tag.id" @click="chooseTag(tag, scope.row)" class="m-b-5 m-r-5 h-cursor d-in-block">
            <el-tag type="info">
              {{tag.name}}
            </el-tag>
          </span>
        </template>
      </el-table-column>
      <el-table-column
        label="已选择" class="tag-wrap">
        <template slot-scope="scope">
          <span v-if="!!tag.selected" v-for="tag in scope.row.tag_list" :key="tag.id" @click="removeTag(tag, scope.row)" class="m-b-5 m-r-5 h-cursor d-in-block">
            <el-tag type="success">
              {{tag.name}}
            </el-tag>
          </span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  name: 'TagChooser',
  props: [
    'tags',
    'value'
  ],
  data () {
    return {
      list: [],
      selected: []
    }
  },
  watch: {
    tags (val) {
      this.init()
    },
    value () {
      this.init()
    }
  },
  methods: {
    init () {
      this.selected = this.value
      this.list = this.tags
      for (let k in this.list) {
        let list = this.list[k]['tag_list']
        for (let i = 0; i < list.length; i++) {
          if (this.value.find(item => list[i]['id'] === item)) {
            list[i]['selected'] = 1
          } else {
            delete list[i]['selected']
          }
        }
      }
      this.list = Object.assign([], this.list)
    },
    chooseTag (row) {
      row.selected = 1
      this.listChange('add', row.id)
    },
    removeTag (row) {
      delete row['selected']
      this.listChange('del', row.id)
    },
    listChange (status, id) {
      if (status === 'add') {
        this.selected.push(id)
      } else {
        this.selected.splice(this.selected.indexOf(id), 1)
      }
      this.$emit('input', this.selected)
    }
  },
  created () {
    this.init()
  }
}
</script>
<style scoped>

</style>
